import { motion } from "framer-motion";

function HorizontalBarChart(props) {
    /**
     * data: Array of objects with key-values of name, score
     * color: string of color name
     */
    const { data, color } = props;
    const gradientShades = [900, 800, 700, 600, 500, 400, 300, 200]

    return (
        <div className="flex flex-col space-y-2">

            {data.map((d, index) => (
                <div className="relative w-full bg-blue-gray-200 rounded-lg" key={index}>
                    <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: `${d.score}%` }}
                        transition={{duration: 4}}
                    >
                        <div
                            className={`bg-${color}-${gradientShades[index]} text-sm font-medium text-left transition ease-in-out hover:-translate-y-1 hover:scale-105 duration-300 rounded-lg ` + 
                            (d.score === 0 ? `m-3 text-${color}-${gradientShades[index]}` : "p-3 text-white")}
                            style={{whiteSpace: 'nowrap'}}
                        >
                            {d.name}
                        </div>
                    </motion.div>
                    <div className="absolute inset-y-2.5 right-2 transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300">
                        <p className={d.score >= 95 ? `text-white` :`text-${color}-${gradientShades[index]}`}>
                            {d.score}%
                        </p>
                    </div>
                </div>
            ))}
                
            <table className="w-full border-collapse border-dashed border-2 border-t-0 h-3.5 text-blue-gray-300">
                <tbody>
                    <tr className="border-dashed border-2 border-t-0 h-3.5">
                        <th className="border-dashed border-2 border-t-0 h-3.5"></th>
                        <th className="border-dashed border-2 border-t-0 h-3.5"></th>
                        <th className="border-dashed border-2 border-t-0 h-3.5"></th>
                        <th className="border-dashed border-2 border-t-0 h-3.5"></th>
                    </tr>
                </tbody>
            </table>
            <div className="grid grid-cols-4 text-blue-gray-300">
                <div>0%</div>
                <div className="-ml-2.5">25%</div>
                <div className="-ml-2.5">50%</div>
                <div className="grid grid-cols-2 gap-x-0">
                    <div className="-ml-2.5">75%</div>
                    <div className="text-right">99%</div>
                </div>
            </div>
        </div>
    );
}

export default HorizontalBarChart;
